__turbopack_context__.v({
  "wrapper": "docs-module-scss-module__htcska__wrapper",
});
